import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-chip-multi-select',
  templateUrl: './chip-multi-select.component.html',
  styleUrls: ['./chip-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChipMultiSelectComponent),
      multi: true,
    },
  ],
})
export class ChipMultiSelectComponent implements ControlValueAccessor {
  @Input() options: any[] = [];
  @Input() placeholder = 'Pilih';
  @Input() disabled = false;
  @Input() removable = true;
  @Input() valueKey = 'id';
  @Input() labelKey = 'text';
  @Input() getLabel?: (value: string) => string;

  @Output() ionChange = new EventEmitter<string[]>();

  value: string[] = [];

  private onChange: (value: string[]) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string[] | null): void {
    this.value = Array.isArray(value) ? [...value] : [];
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  chipLabel(item: string): string {
    if (this.getLabel) {
      return this.getLabel(item) || item;
    }

    const found = (this.options || []).find(
      (option) => String(option?.[this.valueKey] ?? option) === String(item),
    );

    if (found && typeof found === 'object') {
      return found[this.labelKey] ?? found.text ?? found.name ?? String(item);
    }

    return String(item);
  }

  optionValue(option: any): string {
    if (option && typeof option === 'object') {
      return String(option[this.valueKey] ?? option.id ?? option.text ?? '');
    }
    return String(option ?? '');
  }

  optionLabel(option: any): string {
    if (option && typeof option === 'object') {
      return option[this.labelKey] ?? option.text ?? option.name ?? this.optionValue(option);
    }
    return String(option ?? '');
  }

  onValueChange(next: string[] | string) {
    this.value = Array.isArray(next)
      ? [...next]
      : next != null && next !== ''
        ? [String(next)]
        : [];

    this.onChange([...this.value]);
    this.onTouched();
    this.ionChange.emit([...this.value]);
  }

  removeChip(item: string, event?: Event) {
    event?.stopPropagation();

    if (this.disabled || !this.removable) {
      return;
    }

    this.value = (this.value || []).filter((entry) => String(entry) !== String(item));
    this.onChange([...this.value]);
    this.onTouched();
    this.ionChange.emit([...this.value]);
  }
}
